<template>
  <div class="b-white" id="carrousel">
    <b-carousel controls v-if="!isLogin" :interval="10000000000" >
      <b-carousel-slide>
        <template v-slot:img>
          <Welcome/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <Job/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <Courses/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <Enterprise/>
        </template>
      </b-carousel-slide>
    </b-carousel>
    <b-carousel controls v-else>
      <b-carousel-slide>
        <template v-slot:img>
          <WelcomeSession/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <ProfileSession/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <JobSession/>
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <CourseSession/>
        </template>
      </b-carousel-slide>
    </b-carousel>
    <section class="container">
      <div class="row">
        <div class="col-lg-12 text-center py-5">
          <h2 class="font-weight-light font-blue border-bottom-orange d-inline my-5 ">Por y Para ti</h2>

          <div class="d-block font-size-25 my-5 text-justify">
            <h5>
              En Kllaar.com nos <span class="h5 font-weight-bold">apasiona</span> la idea de contribuir al <span
              class="h5 font-weight-bold">desarrollo
              y
              superación</span> de los <span class="h5 font-weight-bold">jóvenes</span> de nuestro país.
              Esta idea nació <span class="h5 font-weight-bold">para ti</span>, comenzó siendo un sitio donde poder
              compartir recursos para
              continuar tu preparación, <span class="h5 font-weight-bold">tú haz hecho posible</span> que este proyecto
              se concrete e inspire
              mucho más.
              <span class="h5 font-weight-bold">Gracias</span> por ser la fuerza y valor principal del México de hoy y
              del futuro.
            </h5>

          </div>

          <h2 class="font-weight-light font-blue border-bottom-orange d-inline my-5">Conectamos</h2>
          <div class="d-block mt-5 text-justify">
            <h5>
              Nuestro <span class="h5 font-weight-bold">desafío</span> es buscar maneras nuevas, <span
              class="h5 font-weight-bold">inteligentes y confiables</span>, no de
              enfrentar al mundo, sino de
              <span class="h5 font-weight-bold">cambiarlo</span>. Esto a través de una <span
              class="h5 font-weight-bold">red profesional</span> que te incluye a ti que
              estás estudiando una carrera o
              acabas de egresar, pero además a quienes están creando oportunidades como <span
              class="h5 font-weight-bold">empresas y
            empleadores</span>, y a
              <span class="h5 font-weight-bold">capacitadores</span> que nos ofrecen lo más actual en cursos y talleres
              para continúes y
              complementes tu
              preparación.
            </h5>
          </div>

          <div class="_register my-5" v-if="!isLogin">
            <h2 class="font-weight-light font-blue border-bottom-orange d-inline">¿Qué estás esperando?</h2>
            <div class="d-block mt-5">
              Únete a Kllaar.com, tu punto de impulso.
              <br>
              <router-link to="/registrar"
                           class="btn b-orange col-lg-3 col-sm-12 col-md-6 mt-4 btn-lg shadow-lg">¡Regístrate ya!
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="row b-gray-light py-1">
      <div class="col-lg-12 text-center py-3">
        <h4>Nuestras Alianzas</h4>
        <div>
          <a href="http://estudiantesembajadores.com/">
            <img src="@/assets/alliance/aliados_estudiantes.png" alt="" class="mx-3" height="70">
          </a>
          <a href="https://kueski.com/?lang=es">
            <img src="@/assets/alliance/aliados_kueski.png" alt="" class="mx-3" height="70">
          </a>
          <a href="https://www.ensenapormexico.org/">
            <img src="@/assets/alliance/aliados_epm.png" alt="" class="mx-3" height="70">
          </a>
          <a href="https://www.wizeline.com/careers/">
            <img src="@/assets/alliance/aliados_wizeline.png" alt="" class="mx-3" height="70">
          </a>
          <a href="http://www.ijalti.org.mx/">
            <img src="@/assets/alliance/aliados_ijalti.png" alt="" class="mx-3" height="70">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  section {
    position: relative;
  }
</style>
<script>
  import Welcome from './slider/Welcome'
  import Job from './slider/Job'
  import Enterprise from './slider/Enterprise'
  import Courses from './slider/Courses'

  import WelcomeSession from './slider/onSession/Welcome'
  import ProfileSession from './slider/onSession/Profile'
  import JobSession from './slider/onSession/Job'
  import CourseSession from './slider/onSession/Course'

  export default {
    components: {
      'Welcome': Welcome,
      'Job': Job,
      'Enterprise': Enterprise,
      'Courses': Courses,
      'WelcomeSession': WelcomeSession,
      'ProfileSession': ProfileSession,
      'JobSession': JobSession,
      'CourseSession': CourseSession
    },
    data() {
      return {}
    },
    computed: {
      isLogin: function () {
        return this.$store.getters.isLoggedIn
      },
      typeOrigin: function () {
        return this.$store.getters.typeOrigin
      }
    },
    created() {
      setTimeout(() => {
        this.$slider.scrollTo('.navbar', 1000)
      }, 300)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#public/home/HomePage.vue